import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';
import { BENI_COMPETITORS_TABS } from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

export default class HotelSettingsCompetitorsBenchmarkSmartCompsetCategoriesRoute extends Route {
  @service declare access: Services['access'];
  @service declare router: Services['router'];
  @service declare transition: Services['transition'];

  beforeModel(transition: Transition): void {
    if (!this.access.hasBenchmarkInsightSmartCompsetEdit) {
      this.transition.redirectToEnabledTab(transition);
    }

    // @ts-expect-error: Object is possibly 'null'.
    const { activeTab } = this.router.currentRoute.queryParams;

    if (!activeTab || activeTab !== BENI_COMPETITORS_TABS.SMART_COMPSET) {
      this.transition.validateBenchmarkInsightSmartCompsetBuilderQueryParams(
        transition,
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/require-await
  async model() {
    return this.modelFor('hotel.settings.competitors.benchmark');
  }
}
